export function mapKey(subject, predicate, thisArg) {
    return Object.keys(subject).map(function (k, i, a) {
        return predicate.apply(this, [k, i, a, subject]);
    }, thisArg);
}
//# sourceMappingURL=mapKey.js.map